<template>
  <div class="sessions-list" ref="sessionList">
    <div class="timestamp-alert"
    :style="{
        background: colors.theme == 'dark' ? `#000` : `#000`,
        color: colors.theme == 'dark' ? `#fff` : `#fff`
    }"    
    >{{$t("components.Dashboard.SessionList.timestampAlert")}}</div>
    <ul class="list">
      <li
        class="item"
        :style="{
            background: colors.secondary,
            color: colors.theme == 'dark' ? `#fff` : `#fff`
        }"            
        v-for="session in sessionsFilter"
        :key="session.id"
        @click="schedule(session)"
        @touch="schedule(session)"
      >
        <div class="date-item">
          <!-- <img class="img-item" src="../../assets/calendar-mini.png" alt /> -->
          <Calendar></Calendar>
          <span class="date">{{ formatDate(session.fields.schedule)}}</span>
        </div>
        <div class="clock-item">
          <!-- <img class="img-item" src="../../assets/clock-mini.png" alt /> -->
            <Clock></Clock>
          <span class="clock">{{ formatHour(session.fields.schedule) }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
var moment = require("moment");
moment.locale("pt-br");
import Bus from "@/main.js";
import Calendar from "../Shared/CustomIcons/Dashboard/Schedule/Calendar.vue"
import Clock from "../Shared/CustomIcons/Dashboard/Schedule/Clock.vue"
export default {
  components:{
    Clock, Calendar
  },
  props: {
    sessions: {
      type: Array,
      required: true
    }
  },
  data(){
      return{
          colors:{}
      }
  },    
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    if (this.sessions.length < 1) {
      this.notHasSessions();
    }
  },
  mounted() {
    let button = document.querySelector(".scheduled-button");
    if (!button) {
      button = document.querySelector(".dash-open-button");
    }
    // let sessionList = this.$refs.sessionList;
    // sessionList.style.width = button.offsetWidth + "px";
  },
  computed: {
    sessionsFilter() {
      const now = moment();
      let sessions = this.sessions;
      const sessionsFilter = sessions.filter(session => {
        return (
          moment(session.fields.schedule) > now &&
          session.fields.status == "open"
        );
      });
      if (sessionsFilter.length < 1) {
        this.notHasSessions();
        return;
      }

      return sessionsFilter;
    }
  },
  methods: {
    notHasSessions() {
      Bus.$emit("openAlertGlobal", {
        imageSrc: "error",
        title: this.$t("components.Dashboard.SessionList.emptySessions.title"),
        subtitle:
          this.$t("components.Dashboard.SessionList.emptySessions.subtitle")
      });
      this.$emit("closeSessionsList");
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatHour(date) {
      return moment(date).format("HH:mm");
    },
    schedule(session) {
      this.$emit("closeSessionsList");
      Bus.$emit("schedule", session.id);
    }
  }
};
</script>
<style lang="scss" scoped>
.sessions-list {
  width: 60%;
  max-height: calc(100vh - 30%);
  position: absolute;
  z-index: 1002;
  top: 240px;
  right: 20px;
  // overflow-y: scroll;
  // overflow-x: hidden;

  .timestamp-alert {
    background-color: #00efe3;
    color: black;
    text-align: center;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
    padding: 6% 0;
  }

  .list {
    width: 100%;
    display: flex;
    flex-direction: column;

    .item {
      margin: 5px 0 0 0;
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      cursor: pointer;

      &:nth-child(odd) {
        background: #ffffff;
      }

      &:nth-child(even) {
        background: #ededed;
      }

      .date-item,
      .clock-item {
        display: flex;
        align-items: center;

        .img-item {
          height: 17px;
        }
        svg{
          width: 25px;
          opacity: 0.5;
        }
      }

      .date,
      .clock {
        font-size: 17px;
        margin-left: 5px;
        font-weight: 800;        
      }

      .date {
        font-weight: 800;
      }
    }
  }
}

@media only screen and (min-width: 750px) {
  .sessions-list {
    top: 175px;
    width: 45%;
    right: 25%;
    .list {
      .item {
        .date-item,
        .clock-item {
          .img-item {
            height: 30px;
          }
          .date,
          .clock {
            font-size: 19px;
          }
        }
      }
    }
  }
}
</style>
